import React, { useEffect, useMemo, useRef, useState } from "react";
import { Html } from "@react-three/drei";
import { useFrame } from "@react-three/fiber";
import { useSpring, animated, config } from "@react-spring/three";
import { history } from "./History";

function Episode11LaserLink({ mobile }) {
  const [active, setActive] = useState(false);
  const group = useRef();

  useEffect(() => {
    document.body.style.cursor = active ? "pointer" : "grab";
  }, [active]);

  useFrame((state) => {
    if (group.current) {
      group.current.rotation.y = state.clock.elapsedTime * 0.35;
    }
  });

  const { scale } = useSpring({
    scale: active ? 1.15 : 1,
    config: config.slow,
  });

  const lasers = useMemo(
    () => [
      { position: [0, 0, 0], rotation: [0, Math.PI / 3, Math.PI / 5], color: "#ff00ff" },
      { position: [0, 0, 0], rotation: [Math.PI / 4, Math.PI / 2, 0], color: "#00ffff" },
      { position: [0, 0, 0], rotation: [Math.PI / 5, 0, Math.PI / 2], color: "#39ff14" },
      { position: [0, 0, 0], rotation: [Math.PI / 2.5, Math.PI / 6, Math.PI / 3], color: "#ff3399" },
      { position: [0, 0, 0], rotation: [Math.PI / 3.2, Math.PI / 1.4, Math.PI / 7], color: "#ffff00" },
      { position: [0, 0, 0], rotation: [Math.PI / 1.8, Math.PI / 5, Math.PI / 1.7], color: "#00ffcc" },
      { position: [0, 0, 0], rotation: [Math.PI / 6, Math.PI / 1.1, Math.PI / 2.4], color: "#ff5500" },
      { position: [0, 0, 0], rotation: [Math.PI / 1.3, Math.PI / 2.8, Math.PI / 4], color: "#b266ff" },
      { position: [0, 0, 0], rotation: [Math.PI / 2.1, Math.PI / 1.9, Math.PI / 1.2], color: "#66ff33" },
    ],
    [],
  );

  const goToEpisode11 = () => {
    history.push("/episode11");
  };

  return (
    <animated.group ref={group} position={[0, 3, 0]} scale={scale}>
      <mesh onPointerEnter={() => setActive(true)} onPointerLeave={() => setActive(false)} onClick={goToEpisode11}>
        <boxGeometry args={[2.4, 2.4, 2.4]} />
        <meshBasicMaterial transparent opacity={0.001} depthWrite={false} />
      </mesh>

      {lasers.map((laser, index) => (
        <mesh key={index} position={laser.position} rotation={laser.rotation}>
          <cylinderGeometry args={[0.02, 0.02, 2.4, 24]} />
          <meshStandardMaterial color={laser.color} emissive={laser.color} emissiveIntensity={2.5} metalness={0.4} roughness={0.2} />
        </mesh>
      ))}

      {(active || mobile) && (
        <Html
          wrapperClass="overlay-wrapper"
          style={{
            transition: "all 0.5s",
            opacity: 1,
          }}
          className="overlay"
          center={true}
          position={[0, 0.9, 0]}
          distanceFactor={10}
        >
          <div className="content">EPISODE 11 : Dancefloor</div>
        </Html>
      )}
    </animated.group>
  );
}

export default Episode11LaserLink;
